"use client";

import type { FC, ReactNode } from "react";
import { useRouter } from "next/navigation";

export const TrComponent: FC<{
  link: string;
  className: string;
  children: ReactNode;
}> = ({ link, children, className }) => {
  const { push } = useRouter();
  return (
    <tr className={className} onClick={() => push(link)}>
      {children}
    </tr>
  );
};
